import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import Logo from '../../components/settings/modals/Logo';
import ClinicInfo from '../../components/settings/modals/ClinicInfo';
import OfficeSwitcher from '../../components/settings/modals/OfficeSwitcher';
import ProfileInfo from '../../components/settings/modals/ProfileInfo';
import Signature from '../../components/settings/modals/Signature';
import AppInfo from '../../components/settings/modals/AppInfo';
import RequirePermission from '../../components/RequirePermission';
import { SUB_MODULES } from '../../constants/subModulesConstants';

const SettingsPage = () => {

    return (
        <>
            <Typography variant="h4">Settings</Typography>
            <List>
                <ProfileInfo />
                <RequirePermission subModuleName={SUB_MODULES.SIGNATURE} minAccessLevel={1}>
                  <Signature />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.CLINIC_CONTACT_INFORMATION} minAccessLevel={1}>
                  <ClinicInfo />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.CLINIC_LOGO} minAccessLevel={1}>
                  <Logo />
                </RequirePermission>
                <RequirePermission subModuleName={SUB_MODULES.SWITCH_CLINIC_BRANCH} minAccessLevel={2}>
                  <OfficeSwitcher />
                </RequirePermission>
                <AppInfo />
            </List>
        </>
    );
};

export default SettingsPage;
